// @ts-nocheck
import React, { useEffect, useState } from "react";
import { setupInterceptorsTo } from "../../Componentes/API/AxiosBuilder";
import axios from 'axios';
import { BodyContext } from "./BodyContext";
import localStorageManagement from "../../Security/LocalStorageManagement";
import { URL_API_SIA, RUTA_API_LDAP } from "../../Contantes/Constantes";
import KeyCloak from "../../Auth/Keycloak";
import { useAuth } from "../../Auth/State/AuthContext";

export function ProvideBody({ error, children }) {
    const contexto = useProvideBody({ error })
    return (
        <BodyContext.Provider value={contexto}>
            {children}
        </BodyContext.Provider>
    );
}

function useProvideBody({ error }) {
    const [message, setMessage] = useState(null);
    const [info, setInfo] = useState(null);
    const [success, setSuccess] = useState(null);
    const [notices, setNotices] = useState({
        'GR': [],
        'PO': [],
        'PR': [],
    });
    const { user, isLogedIn } = useAuth();
    const [loadingBackdrop, setLoadingBackdrop] = useState(false);
    const [noticesNotViews, setNoticesNotViews] = useState([]);
    const [googleImageBase64, setGoogleImageBase64] = useState(null);
    const [openM, setOpenM] = useState(false); // es para el menu lateral, 'openMenu' ya se usa para otra cosa
    const axiosInstance = setupInterceptorsTo(axios.create({
        headers: {
            "Content-Type": "application/json",
        },
    }));

    const fetchNoticias = () => {
        axios({
            method: 'GET',
            url: `${URL_API_SIA}/noticias-utn/ALL`,
        })
            .then((response) => {
                const data = response.data
                const news = {
                    'GR': data.GR ? data.GR : '',
                    'PO': data.PO ? data.PO : '',
                    'PR': data.PR ? data.PR : '',
                }
                setNotices(news);
            })
            .catch((e) => {
                setNotices({
                    'GR': [],
                    'PO': [],
                    'PR': [],
                });
                setMessage("Hubo un error al traer las noticias codigo de error : 00021");
            })
    }

    const fetchGoogleImageBase64 = () => {
        axios({
            method: 'GET',
            url: `${RUTA_API_LDAP}/persona/${user.email}/foto`,
        })
            .then((response) => {
                if (response.data.base64) {
                    setGoogleImageBase64(response.data.base64);
                } else {
                    setGoogleImageBase64(generateBase64Image(user).split(',')[1]);
                }
            })
            .catch((error) => {
                setGoogleImageBase64(generateBase64Image(user).split(',')[1]);
                console.error("Error al obtener la foto de Google: ", error);
            })
    }
    function generateBase64Image(user) {
        const canvas = document.createElement('canvas');
        canvas.width = 100;
        canvas.height = 100;
        const ctx = canvas.getContext('2d');

        let color;
        do {
            color = Math.floor(Math.random() * 16777215).toString(16);
        } while (parseInt(color, 16) > 0xCCCCCC);
        ctx.fillStyle = `#${color}`; ctx.fillRect(0, 0, canvas.width, canvas.height);

        ctx.fillStyle = '#ffffff';
        ctx.font = '50px Arial';
        ctx.textAlign = 'center';
        ctx.textBaseline = 'middle';

        const firstLetter = user.name.charAt(0).toUpperCase();
        ctx.fillText(firstLetter, canvas.width / 2, canvas.height / 2);

        return canvas.toDataURL();
    }
    useEffect(() => {
        fetchNoticias();
    }, []);

    useEffect(() => {
        if (!error && KeyCloak.isLoggedIn() && isLogedIn())
            fetchGoogleImageBase64();
    }, [user]);

    return {
        message, setMessage,
        info, setInfo,
        success, setSuccess,
        notices,
        noticesNotViews, setNoticesNotViews,
        googleImageBase64,
        openM, setOpenM,
        loadingBackdrop, setLoadingBackdrop
    };
}
